import React, { useEffect, useState } from "react";
import Proptypes from "prop-types";
import ReactFlagsSelect from "react-flags-select";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  useDisclosure,
  Flex,
  Box,
  Text,
  Checkbox,
  Link,
  Tooltip,
} from "@chakra-ui/react";
import Logo from "../Common/LogoComponent";
import { countryCodes } from "../Dashboard/EditFields/CountryCodes.json";

const CustomModal = ({ handleOnClose, showModal, handleFormSubmit }) => {
  const [userEmail, setUserEmail] = useState("");
  const [userCountryName, setUserCountryName] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef();
  const finalRef = React.useRef();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const getCountryCodes = () => {
    return countryCodes.map((country) => {
      return country.code;
    });
  };

  const getCountryLabels = () => {
    return countryCodes.map((country) => {
      return country.name;
    });
  };

  const getCountryNameByCode = (e) => {
    let countryName = ""
    countryCodes.map((country) => {
      if(country.code == e) {
        countryName = country.name
      }
    });
    return countryName;
  };
  const handleOnChange = (e, condition) => {
    let value = "";
    if (condition == "countryCode") {
      value = getCountryNameByCode(e);
      console.log("countryName==>",getCountryNameByCode(e),value,e);
    } else {
      e.preventDefault();
      value = e.target.value;
    }
    if (condition == "email") setUserEmail(() => value);
    if (condition == "countryCode") {setUserCountryName(() => value) , setUserCountryCode(() => e)}
  };

  useEffect(() => {
    if (showModal) {
      onOpen();
    }
  }, [showModal]);

  const onSubscribeHandler = (e) => {
    const checked = e.target.checked;
    console.log(
      "🚀 ~ file: Modal.js ~ line 46 ~ onSubscribeHandler ~ checked",
      checked
    );
    setButtonDisabled(!buttonDisabled);
  };
  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={(e) => handleOnClose(e, onClose)}
      size={"lg"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex align="center">
            Welcome to
            <Box ml="1">
              <Logo />
            </Box>
            <Text ml="1">Freshworks form builder</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel fontWeight="500" fontSize="14px">
              Enter your email to start creation forms{" "}
            </FormLabel>
            <Flex w="100%">
              <Box w="48%">
                <Input
                  h="9"
                  ref={initialRef}
                  onChange={(e) => handleOnChange(e, "email")}
                  value={userEmail}
                  placeholder="Enter your business email"
                />
              </Box>
              <Box w="34%">
                <ReactFlagsSelect
                  countries={getCountryCodes()}
                  customLabels={getCountryLabels()}
                  searchable={true}
                  className="react-flag-select"
                  placeholder="Select country"
                  selected={userCountryCode}
                  onSelect={(e) => handleOnChange(e, "countryCode")}
                />
              </Box>
              <Box w="20%" ml="2">
                <Tooltip label="Make sure enable subscripe the checkbox">
                  <Button
                    h="9"
                    onClick={(e) =>
                      handleFormSubmit(e, { userEmail, userCountryName })
                    }
                    //size="md"
                    colorScheme="primary"
                    className="btn--primary"
                    isDisabled={buttonDisabled}
                  >
                    Submit
                  </Button>
                </Tooltip>
              </Box>
            </Flex>
          </FormControl>
          <Box mt="3">
            <Flex align="flex-start">
              <Checkbox
                defaultIsChecked
                onChange={onSubscribeHandler}
              ></Checkbox>
              <Text fontSize="13px" ml="3" align="left">
                I agree to receive electronic marketing communication from
                Freshworks and understand I can unsubscribe by clicking the
                ‘Unsubscribe’ link in any email or by contacting Freshworks
              </Text>
            </Flex>
          </Box>
        </ModalBody>

        <span className="block-separator"></span>
        <ModalFooter>
          <Text fontSize="14px">
            By clicking on{" "}
            <span className="text--grey">START CREATING FORMS</span> you agree
            to our{" "}
            <Link
              isExternal
              color="blue"
              href="https://www.freshworks.com/terms/"
            >
              terms
            </Link>{" "}
            and you acknowledge having read our{" "}
            <Link
              isExternal
              color="blue"
              href="https://www.freshworks.com/privacy/"
            >
              privacy notice
            </Link>
          </Text>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

CustomModal.propTypes = {
  handleOnClose: Proptypes.func.isRequired,
  handleFormSubmit: Proptypes.func.isRequired,
  showModal: Proptypes.bool.isRequired,
};

export default CustomModal;
